// Suggested mappings from JDE F4100 (Warehouse Locations Master) to Nexus Locations grid
// Source: user-provided CSV mapping guide

export const jdeF4100Fields = [
  { id: "LMMCU", label: "LMMCU (Business Unit)" },
  { id: "LMLOCN", label: "LMLOCN (Location)" },
  { id: "LMAISL", label: "LMAISL (Aisle)" },
  { id: "LMBIN", label: "LMBIN (Bin)" },
  { id: "LMLA03", label: "LMLA03 (Category Code - Location 03)" },
  { id: "LMLA04", label: "LMLA04 (Category Code - Location 04)" },
  { id: "LMLA05", label: "LMLA05 (Category Code - Location 05)" },
  { id: "LMLA06", label: "LMLA06 (Category Code - Location 06)" },
  { id: "LMLA07", label: "LMLA07 (Category Code - Location 07)" },
  { id: "LMLA08", label: "LMLA08 (Category Code - Location 08)" },
  { id: "LMLA09", label: "LMLA09 (Category Code - Location 09)" },
  { id: "LMLA10", label: "LMLA10 (Category Code - Location 10)" },
  { id: "LMLHLD", label: "LMLHLD (Hold Code - Location)" },
  { id: "LMFREZ", label: "LMFREZ (Freeze Rule)" },
  { id: "LMNETA", label: "LMNETA (Nettable / Allocatable)" },
  { id: "LMLCOD", label: "LMLCOD (Tax Status Code)" },
  { id: "LMEQTY", label: "LMEQTY (Container Code)" },
  { id: "LMMITM", label: "LMMITM (Maximum Number of Items)" },
  { id: "LMSTAG", label: "LMSTAG (Staging Location Y/N)" },
  { id: "LMLVER", label: "LMLVER (Location Verification Code)" },
  { id: "LMUPMJ", label: "LMUPMJ (Date - Updated)" },
  { id: "LMTDAY", label: "LMTDAY (Time of Day)" },
  { id: "LMUSER", label: "LMUSER (User ID)" },
  { id: "LMPID", label: "LMPID (Program ID)" },
  { id: "LMJOBN", label: "LMJOBN (Work Station ID)" },
  { id: "LMSTGR", label: "LMSTGR (Staging Location - Replenishment)" },
  { id: "LMDISX", label: "LMDISX (Latitude)" },
  { id: "LMDISY", label: "LMDISY (Longitude)" },
  { id: "LMDISZ", label: "LMDISZ (Height)" },
];

// Default suggestions -> Nexus grid fields
// Only targets that exist in the Locations grid are proposed
export const suggestedTargetByJde = {
  // LMMCU: no default
  LMLOCN: "locationId",
  // Prefer LMLA07 for subregion; leave LMAISL unmapped by default
  // LMAISL: "subregion",
  // LMBIN: none
  LMLA03: "locationUsage",
  // LMLA04: consider mapping manually if needed
  LMLA05: "locationType",
  LMLA06: "regionName",
  LMLA07: "subregion",
  LMLA08: "countryId",
  // LMLA09: none (currency)
  LMLA10: "languageId",
  // LMLHLD: none
  // LMFREZ: none
  // LMNETA: none
  // LMLCOD: none
  // LMEQTY: could also inform locationType; leave for manual choice
  // LMMITM: none
  // LMSTAG: could derive staging in locationType; leave unmapped
  // LMLVER: none
  // LMUPMJ: none
  // LMTDAY: none
  // LMUSER: none
  // LMPID: none
  // LMJOBN: none
  // LMSTGR: none
  // LMDISX/Y/Z: none (could enrich address/geo)
};

// Targets we care about in Locations grid
export const locationGridTargets = [
  { id: "locationName", label: "Location Name" },
  { id: "locationId", label: "Location ID" },
  { id: "locationUsage", label: "Location Usage" },
  { id: "locationType", label: "Location Type" },
  { id: "languageId", label: "Language ID" },
  { id: "timeZoneId", label: "Time Zone ID" },
  { id: "countryId", label: "Country ID" },
  { id: "address", label: "Address" },
  { id: "subregion", label: "Subregion" },
  { id: "commUsage", label: "Communication Usage Behavior" },
  { id: "regionName", label: "Region Name" },
];

// Build initial mapping suggestions for NexusMappingEditor (targetId -> {mappingType, sourceId})
export function buildInitialMappingsFromSuggestions() {
  const initial = {};
  Object.entries(suggestedTargetByJde).forEach(([jdeField, targetId]) => {
    if (!targetId) return;
    initial[targetId] = { mappingType: "direct", sourceId: jdeField };
  });
  return initial;
}

// Build a SELECT against jde.F4100 using current mappings
// - For each direct mapping, include "<source> AS <target>"
export function buildSelectForF4100(mappings) {
  const pairs = Object.entries(mappings || {})
    .filter(([, v]) => v && v.mappingType === "direct" && v.sourceId)
    .map(([targetId, v]) => ({ targetId, sourceId: v.sourceId }));

  if (pairs.length === 0) {
    return "-- No direct mappings selected yet. Add mappings to generate the SELECT.\nSELECT TOP (100) *\nFROM jde.F4100;";
  }

  const selectList = pairs
    .map(({ targetId, sourceId }) => `  ${sourceId} AS [${targetId}]`)
    .join(",\n");

  const sql = `-- Auto-generated from JDE F4100 mapping\nSELECT\n${selectList}\nFROM jde.F4100;`;
  return sql;
}
